import axios from "axios";
const httpClient = axios.create({
    //baseURL:"http://"+window.location.hostname+":8080/rest/",
    baseURL:process.env.NODE_ENV === 'production' ? (process.env.BASE_URL+"api/rest/") : (process.env.BASE_URL+"rest/"),
    timeout:50000,
    headers:{
        "content-type":"application/json;charset=utf-8"
    }
})

//响应拦截
httpClient.interceptors.response.use((res)=>{
    const status:number = res.status;

    if(status!=200){
        return Promise.reject(res)
    }

    return res;
}, (err)=>{
    console.log(err);
})

export default httpClient;